// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".site-search input{font-size:16px}@media(min-width:1025px)and (max-width:1090px){.site-search .site-search-suggestions{width:130%}}@media(min-width:1091px)and (max-width:1200px){.site-search .site-search-suggestions{width:120%}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
